import { Component, inject, Signal } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalStateSelector } from '@state/global/global.selectors';
import { Store } from '@ngxs/store';
import { HeaderComponent } from '../header/header.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

import { TranslocoModule } from '@jsverse/transloco';
import { SvgSelectorComponent } from '@shared/components/svg-selector/svg-selector.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    imports: [HeaderComponent, MatSidenavModule, MatListModule, RouterModule, TranslocoModule, SvgSelectorComponent, MatIconModule]
})
export class NavbarComponent {
  private store = inject(Store);

  visibleSideNav$: Signal<boolean> = this.store.selectSignal(GlobalStateSelector.navbarVisible);

  constructor() {}
}
